import client from './_portalBackendServiceClient'
import cloneDeep from 'lodash.clonedeep'
import {i18n} from '@/locales'

function formatAmount(card) {
  let twoDecimal = Number(card.amount.replace(/[,]/g, '.')).toFixed(2)

  return parseInt(twoDecimal.replace(/[.]/g,''))
}

function login(username, password) {
  return new Promise((resolve, reject) => {
    client
      .post('/authenticate/user', {
        username: username.toLowerCase().trim(),
        password: password.trim()
      })
      .then(() => resolve())
      .catch(err => reject(err))
  })
}

function getCards() {
  return new Promise(((resolve, reject) => {
    client
      .get('/user/cards')
      .then(({data}) => resolve(data))
      .catch(error => {
        if (error.response) {
          reject(error.response)
        }
        reject(error)
      })
  }))
}

function getCard(cardId) {
  return new Promise((resolve, reject) => {
    client
      .get(`/user/card/${cardId}`)
      .then(({data}) => resolve(data))
      .catch(error => {
        if (error.response) {
          reject(error.response)
        }
        reject(error)
      })
  })
}

function saveCard(card) {
  return new Promise((resolve, reject) => {
    let localCard = cloneDeep(card)
    if (localCard.hasOwnProperty('amount')) {
      localCard.amount = formatAmount(localCard)
    }

    client
      .post('/user/card', localCard)
      .then(() => resolve())
      .catch(error => {
        if (error.response) {
          reject(error.response)
        }
        reject(error)
      })
  })
}

function removeCard(cardId) {
  return new Promise((resolve, reject) => {
    client
      .delete(`/user/card/${cardId}`)
      .then(() => resolve())
      .catch(error => {
        if (error.response) {
          reject(error.response)
        }
        reject(error)
      })
  })
}

function createAccount(account) {
  return new Promise((resolve, reject) => {
    let localAccount = cloneDeep(account)
    if (localAccount.hasOwnProperty('email')) {
      localAccount.email = localAccount.email.toLowerCase().trim()
    }
    if (localAccount.hasOwnProperty('card') && localAccount.card.hasOwnProperty('amount')) {
      localAccount.card.amount = formatAmount(localAccount.card)
    }

    localAccount.language = i18n.locale

    client
      .post('/account', localAccount)
      .then(() => resolve())
      .catch(error => {
        if (error.response) {
          reject(error.response)
        }
        reject(error)
      })
  })
}

function editProfile(profile) {
  return new Promise((resolve, reject) => {
    client.put('/user/profile', profile)
      .then(({data}) => resolve(data))
      .catch(({response}) => reject({
        statusText: response.statusText,
        error: response.data.error,
        passwordErrorMessages: response.data.password_errors || [],
        data: response
      }))
  })
}

function resetPassword(username) {
  return new Promise((resolve, reject) => {
    client
      .post('/user/password_reset_start', {
        username: username,
        domain_symbol: process.env.VUE_APP_PASSENGER_PORTAL_DOMAIN,
        language: i18n.locale
      })
      .then(() => resolve())
      .catch(({response}) => reject({
        statusText: response.statusText,
        error: response.data.error,
        data: response
      }))
  })
}

// ================= FAVOURITES ===================

function addFavourite(cardId, xspit, favourite) {
  return new Promise((resolve, reject) => {
    client
      .put(`/favourites/${cardId}/sales-packages/${xspit}`, favourite)
      .then(({data}) => resolve(data))
      .catch(({response}) => reject({
        statusText: response.statusText,
        error: response.data.error
      }))
  })
}

function deleteFavourite(cardId, xspit) {
  return new Promise((resolve, reject) => {
    client
      .delete(`/favourites/${cardId}/sales-packages/${xspit}`)
      .then(() => resolve())
      .catch(({response}) => reject({
        statusText: response.statusText,
        error: response.data.error
      }))
  })
}

export default {
  login,
  getCards,
  getCard,
  saveCard,
  removeCard,
  createAccount,
  editProfile,
  resetPassword,
  addFavourite,
  deleteFavourite
}
